const _version = "2.13.0"
function version() {
    return _version
}
export default version
